import { render } from "./FooterSchedule.vue?vue&type=template&id=80294a44&scoped=true&ts=true"
import script from "./FooterSchedule.vue?vue&type=script&lang=ts"
export * from "./FooterSchedule.vue?vue&type=script&lang=ts"

import "./FooterSchedule.scss?vue&type=style&index=0&id=80294a44&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80294a44"]])

export default __exports__